module.exports = __webpack_public_path__ + "img/ctrl-u2-1.d15052fe.svg";